
import {bookingManagementActionTypes} from './bookingManagement.actiontype';

export const actions = {
  request: () => ({ type: bookingManagementActionTypes.REQUEST }),
  complete: () => ({ type: bookingManagementActionTypes.COMPLETE }),
  getSlots: (data) => ({ type: bookingManagementActionTypes.GET_SLOTS, data }),
  getUsers: (data) => ({ type: bookingManagementActionTypes.GET_USERS, data }),
};